export default __webpack_public_path__ + "static/media/vintage45g-3.d0d751c9.jpg";